import React, { FC, memo, useCallback, useContext } from 'react';
import { useLegoElementError, useLegoElementValue } from '../../hooks';
import { TLegoElementProps } from '../../models';
import { LegoV2Context } from '../../context';
import { DatePicker } from '@src/atoms/DatePicker';
import { getErrorsMessage } from '../../utils';

export const LegoElementDatePicker: FC<
  TLegoElementProps & Omit<Parameters<typeof DatePicker>[0], 'id' | 'onChange' | 'errorMessage' | 'isHelpMessage'>
> = memo(({ id, ...props }) => {
  const { value, onChange } = useLegoElementValue(id);
  const { validate } = useContext(LegoV2Context);
  const { errorMessage } = useLegoElementError(id);

  const handleChange = useCallback(
    (date: string | string[] | null | (null | string)[]) => {
      onChange(date);
      validate(id, date);
    },
    [id, onChange, validate],
  );

  return (
    <DatePicker
      {...props}
      id={id}
      value={value}
      isHelpMessage
      onChange={handleChange}
      errorMessage={getErrorsMessage(errorMessage)}
    />
  );
});
